import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

const MainLayout = () => {
  return (
    <div className="flex h-screen w-full bg-cyan-grid">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 relative">
        {/* Ambient background glow */}
        <div className="absolute top-0 left-1/4 w-1/2 h-96 bg-cyan-900/10 blur-[120px] pointer-events-none rounded-full"></div>
        <div className="absolute bottom-0 right-1/4 w-1/3 h-64 bg-amber-900/5 blur-[100px] pointer-events-none rounded-full"></div>
        
        <Header />
        <main className="flex-1 overflow-y-auto p-6 relative z-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;